import {
  ListUserActivityLogActivityTypesRO,
  ListUserActivityLogCompaniesRO,
  ListUserActivityLogUsersRO,
  ListUserActivityLogsRO,
} from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { FetchDataParamsWithToken } from "types";
import { UserAuditLogFilters } from "./UserAuditLog.filters";
import { defaultListUserActivityLogsParams } from "./UserAuditLog.utils";

export type UserAuditLogOrderBy = "id" | "loggedAt" | "activityName";

export type ListUserActivityLogsParams =
  FetchDataParamsWithToken<UserAuditLogOrderBy> & UserAuditLogFilters;

export { defaultListUserActivityLogsParams };

export const listUserActivityLogs = async (
  params: ListUserActivityLogsParams = defaultListUserActivityLogsParams,
): Promise<ListUserActivityLogsRO> => {
  const { data } = await apiService.get<ListUserActivityLogsRO>(
    Endpoints.UserAuditLog.Get.List,
    {
      params: normalizeListUserActivityLogsParams(params),
    },
  );

  return data;
};

const normalizeListUserActivityLogsParams = ({
  search,
  activityNames,
  startDate,
  endDate,
  companyId,
  userIds,
  ...params
}: ListUserActivityLogsParams) => ({
  ...params,
  ...(search?.trim() ? { search } : {}),
  ...(activityNames?.length > 0 ? { activityNames } : {}),
  ...(startDate ? { startDate } : {}),
  ...(endDate ? { endDate } : {}),
  ...(companyId ? { companyId } : {}),
  ...(userIds.length > 0 ? { userIds } : {}),
});

export const listUserActivityLogActivityTypes =
  async (): Promise<ListUserActivityLogActivityTypesRO> => {
    const { data } = await apiService.get<ListUserActivityLogActivityTypesRO>(
      Endpoints.UserAuditLog.Get.ActivityTypes,
    );

    return data;
  };

export const listUserActivityLogCompanies =
  async (): Promise<ListUserActivityLogCompaniesRO> => {
    const { data } = await apiService.get<ListUserActivityLogCompaniesRO>(
      Endpoints.UserAuditLog.Get.Companies,
    );

    return data;
  };

export const listUserActivityLogUsers =
  async (): Promise<ListUserActivityLogUsersRO> => {
    const { data } = await apiService.get<ListUserActivityLogUsersRO>(
      Endpoints.UserAuditLog.Get.Users,
    );

    return data;
  };

export const buildUserAuditLogExportParams = ({
  search,
  activityNames,
  startDate,
  endDate,
  companyId,
  userIds,
}: UserAuditLogFilters): Partial<Record<keyof UserAuditLogFilters, string>> => {
  const params: Partial<Record<keyof UserAuditLogFilters, string>> = {};

  if (search.trim()) {
    params.search = search;
  }

  if (activityNames.length > 0) {
    params.activityNames = activityNames.join(",");
  }

  if (startDate) {
    params.startDate = startDate;
  }

  if (endDate) {
    params.endDate = endDate;
  }

  if (companyId) {
    params.companyId = String(companyId);
  }

  if (userIds.length > 0) {
    params.userIds = userIds.join(",");
  }

  return params;
};
